import { useQuery } from '@tanstack/react-query'
import { auditLogApi, GetAuditLogsParams } from '../services/auditLogs'

export const auditLogKeys = {
  all: ['audit-logs'] as const,
  lists: () => [...auditLogKeys.all, 'list'] as const,
  list: (params?: GetAuditLogsParams) => [...auditLogKeys.lists(), params] as const,
}

export function useAuditLogsList(params?: GetAuditLogsParams) {
  return useQuery({
    queryKey: auditLogKeys.list(params),
    queryFn: () => auditLogApi.getAll(params),
  })
}
